/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDrugDestructionCommand } from '../models/CreateDrugDestructionCommand';
import type { DrugDestructionDtoResponse } from '../models/DrugDestructionDtoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugDestructionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param batchId
     * @returns DrugDestructionDtoResponse Success
     * @throws ApiError
     */
    public getApiDrugDestructionsDrugDestructionByBatch(
        batchId: string,
    ): CancelablePromise<DrugDestructionDtoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugDestructions/DrugDestructionByBatch/{batchId}',
            path: {
                'batchId': batchId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugDestructionDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugDestructionsCreateDrugDestruction(
        requestBody?: CreateDrugDestructionCommand,
    ): CancelablePromise<DrugDestructionDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugDestructions/CreateDrugDestruction',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
